import { z } from "zod";

/** Mirrors trading-api's `RiskControlsResponse` (additionalProperties: false). */
export const riskControlsSchema = z.object({
  account_id: z.string(),
  suspend_trading: z.boolean(),
  liquidation_only: z.boolean(),
});

export type RiskControls = z.infer<typeof riskControlsSchema>;
